import { useEffect } from "react";

const usePortalBodyClass = () => {
  useEffect(() => {
    document.body.classList.add("portal-body");
    document.documentElement.classList.add("portal-root");
    return () => {
      document.body.classList.remove("portal-body");
      document.documentElement.classList.remove("portal-root");
    };
  }, []);
};

export default usePortalBodyClass;
